"use strict";const t=require("react"),e=t.createContext({});module.exports=e;
